import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Printer, DownloadSimple, ArrowLeft } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SantriIDCard() {
  const { id } = useParams();
  const [card, setCard] = useState(null);

  useEffect(() => {
    api.get(`/santri/${id}/id-card`).then((r) => setCard(r.data)).catch((e) => toast.error(e.message));
  }, [id]);

  const downloadPdf = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/santri/${id}/id-card.pdf`, { credentials: "include" });
      if (!res.ok) throw new Error("Gagal");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `kartu_${card?.santri?.nis || id}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(e.message); }
  };

  if (!card) return <div className="text-slate-500">Memuat...</div>;
  const s = card.santri;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Link to={`/santri/${id}`} className="imsyaf-btn-ghost"><ArrowLeft size={16} /></Link>
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400">Kartu Identitas Santri</div>
            <h1 className="font-display text-3xl font-bold text-[#064E3B]">{s.nama}</h1>
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={() => window.print()} className="imsyaf-btn-outline" data-testid="print-card-btn"><Printer size={16}/> Cetak</button>
          <button onClick={downloadPdf} className="imsyaf-btn-primary" data-testid="download-card-pdf"><DownloadSimple size={16}/> Unduh PDF</button>
        </div>
      </div>

      <div className="print:block">
        <div id="printable-card" className="mx-auto max-w-md">
          <div className="relative rounded-2xl overflow-hidden shadow-xl border border-green-900/10 bg-white islamic-pattern">
            <div className="bg-[#14532d] text-white px-5 py-3">
              <div className="text-[10px] uppercase tracking-widest opacity-80">Pondok Pesantren</div>
              <div className="font-display font-bold text-sm">AL-IMAM ASY-SYAFI'I TARAKAN</div>
            </div>
            <div className="p-5 grid grid-cols-[1fr,auto] gap-4">
              <div className="min-w-0 space-y-1.5">
                <div>
                  <div className="text-[10px] uppercase text-slate-500">NIS</div>
                  <div className="font-mono text-sm">{s.nis}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase text-slate-500">Nama</div>
                  <div className="font-display font-bold text-lg text-[#064E3B] leading-tight">{s.nama}</div>
                </div>
                <div className="grid grid-cols-3 gap-2 text-xs pt-1">
                  <div><div className="text-slate-500 text-[9px] uppercase">Kelas</div><div className="font-medium">{s.kelas_nama || "-"}</div></div>
                  <div><div className="text-slate-500 text-[9px] uppercase">Kamar</div><div className="font-medium">{s.kamar_nama || "-"}</div></div>
                  <div><div className="text-slate-500 text-[9px] uppercase">Halaqah</div><div className="font-medium">{s.halaqah_nama || "-"}</div></div>
                </div>
                <div className="pt-1">
                  <span className={`imsyaf-badge ${s.status === "aktif" ? "bg-green-100 text-green-800" : "bg-slate-100 text-slate-700"}`}>{s.status?.toUpperCase()}</span>
                </div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div className="w-24 h-28 rounded-md border border-slate-200 bg-gradient-to-b from-green-50 to-green-100 grid place-items-center text-green-800 text-3xl font-bold">
                  {(s.nama || "S").charAt(0)}
                </div>
                <img alt="QR" src={card.qr_data_url} className="w-24 h-24" data-testid="card-qr" />
              </div>
            </div>
            <div className="px-5 pb-4">
              <img alt="Barcode" src={card.barcode_data_url} className="w-full h-14 object-contain" data-testid="card-barcode" />
              <div className="text-center text-[10px] text-slate-400 mt-1">Scan QR atau Barcode untuk absensi</div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media print {
          body * { visibility: hidden; }
          #printable-card, #printable-card * { visibility: visible; }
          #printable-card { position: absolute; inset: 0; }
        }
      `}</style>
    </div>
  );
}
